import { useCallback, useState } from 'react';
import { EMPTY_CLIENT_FILTER_SELECTION, isClientFilterSelectionActive } from '../../../types/ClientManagementTypes';
import type { ClientFilterSelection } from '../../../types/ClientManagementTypes';

// Owns the FILTERS dropdown's draft/applied state. The applied selection reaches
// the listing query key only: GET /admin/clients accepts no filter parameters yet.
export const useClientFilterSelection = () => {
  const [draftSelection, setDraftSelection] = useState<ClientFilterSelection>(EMPTY_CLIENT_FILTER_SELECTION);
  const [appliedSelection, setAppliedSelection] = useState<ClientFilterSelection>(EMPTY_CLIENT_FILTER_SELECTION);
  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const isFilterActive = isClientFilterSelectionActive(appliedSelection);

  const handleDraftSelectionChange = useCallback(
    (partial: Partial<ClientFilterSelection>) => setDraftSelection((prev) => ({ ...prev, ...partial })),
    [],
  );

  const handleApplyFilters = useCallback(() => {
    setAppliedSelection(draftSelection);
    setFilterDropdownOpen(false);
  }, [draftSelection]);

  const handleClearAllFilters = useCallback(() => {
    setDraftSelection(EMPTY_CLIENT_FILTER_SELECTION);
    setAppliedSelection(EMPTY_CLIENT_FILTER_SELECTION);
  }, []);

  const handleFilterDropdownOpenChange = useCallback(
    (open: boolean) => {
      setFilterDropdownOpen(open);
      if (open) setDraftSelection(appliedSelection);
    },
    [appliedSelection],
  );

  return {
    draftSelection,
    appliedSelection,
    isFilterActive,
    filterDropdownOpen,
    handleDraftSelectionChange,
    handleApplyFilters,
    handleClearAllFilters,
    handleFilterDropdownOpenChange,
  };
};
